import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("@/app/layouts/AuthLayout.vue"),
    meta: { guestOnly: true },
    redirect: { name: "Login" },
    children: [
      {
        path: "login",
        name: "Login",
        component: () => import("@/domains/auth/pages/LoginPage.vue"),
      },
      {
        path: "forgot-password",
        name: "ForgotPassword",
        component: () => import("@/domains/auth/pages/ForgotPasswordPage.vue"),
      },
      {
        path: "reset-password/:token",
        name: "ResetPassword",
        component: () => import("@/domains/auth/pages/ResetPasswordPage.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/app/layouts/AdminLayout.vue"),
    meta: { requiresAuth: true },
    redirect: { name: "Dashboard" },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/domains/dashboard/pages/DashboardPage.vue"),
      },
      {
        path: "users",
        name: "Users",
        component: () => import("@/domains/users/pages/UsersPage.vue"),
      },
      {
        path: "users/:id",
        name: "UserDetail",
        component: () => import("@/domains/users/pages/UserDetailPage.vue"),
        props: true,
      },
      {
        path: "scrolls",
        name: "Scrolls",
        component: () => import("@/domains/scrolls/pages/ScrollsPage.vue"),
      },
      {
        path: "scrolls/:id",
        name: "ScrollDetail",
        component: () => import("@/domains/scrolls/pages/ScrollDetailPage.vue"),
        props: true,
      },
      {
        path: "convert-videos",
        name: "ConvertVideos",
        component: () => import("@/domains/scrolls/pages/ConvertVideosPage.vue"),
      },
      {
        path: "prays",
        name: "Prays",
        component: () => import("@/domains/prays/pages/PraysPage.vue"),
      },
      {
        path: "prays/:id",
        name: "PrayDetail",
        component: () => import("@/domains/prays/pages/PrayDetailPage.vue"),
        props: true,
      },
      {
        path: "circles",
        name: "Circles",
        component: () => import("@/domains/circles/pages/CirclesPage.vue"),
      },
      {
        path: "hubs",
        name: "Hubs",
        component: () => import("@/domains/hubs/pages/HubsPage.vue"),
      },
      {
        path: "moderation",
        name: "ModerationQueue",
        component: () => import("@/domains/moderation/pages/ModerationQueuePage.vue"),
      },
      {
        path: "moderation/settings",
        name: "ModerationSettings",
        component: () => import("@/domains/moderation/pages/ModerationSettingsPage.vue"),
      },
      {
        path: "invitations",
        name: "Invitations",
        component: () => import("@/domains/invitations/pages/InvitationsPage.vue"),
      },
      {
        path: "approvals",
        name: "Approvals",
        component: () => import("@/domains/approvals/pages/ApprovalsPage.vue"),
      },
      {
        path: "waitlist",
        redirect: { name: "Approvals" },
      },
      {
        path: "admins",
        name: "Admins",
        component: () => import("@/domains/admins/pages/AdminsPage.vue"),
        meta: { permission: "admins.manage" },
      },
      {
        path: "audit-logs/auth",
        name: "AuthAuditLogs",
        component: () => import("@/domains/audit-logs/pages/AuthAuditLogsPage.vue"),
        meta: { superAdminOnly: true },
      },
      {
        path: "tags",
        name: "Tags",
        component: () => import("@/domains/tags/pages/TagsPage.vue"),
      },
      {
        path: "video-categories",
        name: "VideoCategories",
        component: () => import("@/domains/video-categories/pages/VideoCategoriesPage.vue"),
      },
      {
        path: "legal-pages",
        name: "LegalPages",
        component: () => import("@/domains/legal/pages/LegalPagesPage.vue"),
      },
      {
        path: "legal-pages/:id",
        name: "LegalPageDetail",
        component: () => import("@/domains/legal/pages/LegalPageDetailPage.vue"),
        props: true,
      },
      {
        path: "settings",
        name: "GlobalSettings",
        component: () => import("@/domains/settings/pages/GlobalSettingsPage.vue"),
        meta: { permission: "settings.change" },
      },
      {
        path: "feed-ranking",
        name: "FeedRanking",
        component: () => import("@/domains/settings/pages/FeedRankingPage.vue"),
      },
      {
        path: "profile",
        name: "Profile",
        component: () => import("@/domains/auth/pages/ProfilePage.vue"),
      },
    ],
  },
];
